export default __webpack_public_path__ + "static/media/bg2_m.f3225265.png";